import React, { useEffect, useState } from 'react';

import { DraggableProvided } from 'react-beautiful-dnd';

import { ErrorMessage } from '@components/common';
import { Field, FieldProps } from '@components/shared/DraggableFields/components';

interface Props extends FieldProps {
  isDragDisabled?: boolean;
  dragProvided: DraggableProvided;
  isDragging?: boolean;
  shouldValidate?: boolean;
  fields: FieldData[];
}

export const DraggableField: React.FC<React.PropsWithChildren<Props>> = ({
  dragProvided,
  isDragging,
  field,
  isDragDisabled,
  onChange,
  shouldValidate = true,
  fields,
  ...rest
}) => {
  const [error, setError] = useState<string>('');

  const handleChange = (field: FieldData) => {
    onChange?.(field);
  };

  useEffect(() => {
    if (shouldValidate) {
      if (!field.label) {
        setError('The label cannot be empty');
      } else if (fields.some((f) => f.label === field.label && f.position !== field.position)) {
        setError('The label must be unique');
      } else if (error) {
        setError('');
      }
    }
  }, [field.label, fields]);

  useEffect(() => {
    if (isDragging && error) {
      setError('');
    }
  }, [isDragging]);

  return (
    <div ref={dragProvided.innerRef} {...dragProvided.draggableProps}>
      <Field field={field} onChange={handleChange} dragHandleProps={dragProvided.dragHandleProps} {...rest} />
      {error && (
        <ErrorMessage aria-label='Error message' icon='warning' size='small' className='my-2'>
          {error}
        </ErrorMessage>
      )}
    </div>
  );
};
